const opositeNumber = (n: number): number => {
  if (n === 0) return 0
  return -n
}

export default opositeNumber
